<template>
    <v-container>
        <v-row justify="center" class="mt-10">
            <img src="@/assets/bns.svg" class="my-10" width="300rem"/>
        </v-row>
        <v-row justify="center">
            <v-col md="2">
            <v-text-field color="#920825" v-model="username" label="Felhasználónév" outlined ></v-text-field>
            </v-col>
            <v-col md="2">
            <v-text-field color="#920825" v-model="password" type="password" label="Jelszó" outlined></v-text-field>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col md=4>
                <v-btn @click="login" width="100%" color="#920825" class="white--text">
                    Belépés
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import api from '@/util/api_util'
export default {
    name: 'Admin',
    data(){
        return{
            username:'',
            password:''
        }
    },
    methods:{
        login(){
            let body = {
                    username:this.username,
                    password:this.password
                };
            api.post("/login",body).then(response=>{
                console.log(response);
                if (response.status == 200){
                    
                }
            })
        }
    }
}
</script>